import { useEffect } from 'react';
import Header from '../home/components/Header';
import Footer from '../home/components/Footer';

export default function TraumatologoVeterinarioAtarfe() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const servicios = [
    {
      icon: 'ri-heart-pulse-line',
      titulo: 'Cirugía TPLO',
      descripcion: 'Especialista en cirugía, TPLO (Osteotomía de Nivelación de la Meseta Tibial) para rotura de ligamento cruzado. Técnica quirúrgica avanzada con resultados excepcionales en Atarfe.'
    },
    {
      icon: 'ri-bone-line',
      titulo: 'Fracturas Complejas',
      descripcion: 'Tratamiento especializado de fracturas mediante osteosíntesis con placas bloqueadas y fijadores externos. Equipamiento de última generación en Atarfe.'
    },
    {
      icon: 'ri-footprint-line',
      titulo: 'Luxación de Rótula',
      descripcion: 'Corrección quirúrgica de luxación patelar mediante técnicas combinadas: transposición de cresta tibial, profundización del surco troclear y liberación de tejidos blandos.'
    },
    {
      icon: 'ri-contrast-drop-2-line',
      titulo: 'Artroscopias',
      descripcion: 'Cirugía mínimamente invasiva para diagnóstico y tratamiento de patologías articulares. Menor dolor postoperatorio y recuperación más rápida.'
    },
    {
      icon: 'ri-brain-line',
      titulo: 'Neurocirugía Veterinaria',
      descripcion: 'Tratamiento de hernias discales, compresiones vertebrales, slot ventral, hemilaminectomía, enfermedad degenerativa lumbosacra y luxaciones vertebrales.'
    },
    {
      icon: 'ri-microscope-line',
      titulo: 'Cirugía Oncológica',
      descripcion: 'Resección de tumores con márgenes oncológicos adecuados, mastectomías, amputaciones y cirugía reconstructiva. Trabajo coordinado con oncólogos.'
    }
  ];

  const razones = [
    {
      icon: 'ri-award-line',
      titulo: 'Más de 25 Años de Experiencia',
      descripcion: 'Especialista dedicado exclusivamente a cirugía veterinaria con casi 5000 intervenciones realizadas en traumatología, oncología y neurocirugía.'
    },
    {
      icon: 'ri-truck-line',
      titulo: 'Servicio Móvil en Atarfe',
      descripcion: 'Me desplazo a tu clínica veterinaria en Atarfe con todo el equipamiento quirúrgico de última generación. Tu paciente opera en su entorno de confianza.'
    },
    {
      icon: 'ri-tools-line',
      titulo: 'Tecnología de Vanguardia',
      descripcion: 'Equipamiento ortopédico de máxima especialización: placas bloqueadas, instrumental de precisión, sistemas de fijación avanzados y material quirúrgico de última generación.'
    },
    {
      icon: 'ri-heart-line',
      titulo: 'Atención Personalizada',
      descripcion: 'Valoración detallada de cada caso, segunda opinión especializada y seguimiento postoperatorio completo. Disponibilidad para consultas en Atarfe y área metropolitana de Granada.'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />

      <div className="bg-gray-50 border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex items-center space-x-2 text-sm">
            <a href="/" className="text-gray-500 hover:text-accent-600 transition-colors cursor-pointer">Inicio</a>
            <i className="ri-arrow-right-s-line text-gray-400"></i>
            <a href="/zonas-servicio" className="text-gray-500 hover:text-accent-600 transition-colors cursor-pointer">Zonas de Servicio</a>
            <i className="ri-arrow-right-s-line text-gray-400"></i>
            <span className="text-gray-900 font-semibold">Traumatólogo Veterinario Atarfe</span>
          </div>
        </div>
      </div>

      <section className="relative bg-gradient-to-br from-accent-50 via-white to-accent-50 py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center max-w-4xl mx-auto">
            <div className="inline-block bg-accent-100 text-accent-800 px-4 py-2 rounded-full text-sm font-semibold mb-6">
              <i className="ri-map-pin-line mr-2"></i>Servicio en Atarfe, Granada
            </div>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-6" style={{ fontFamily: "'Playfair Display', serif" }}>
              <strong>Traumatólogo Veterinario</strong> en Atarfe
            </h1>
            <p className="text-xl text-gray-600 mb-8 leading-relaxed">
              Cirugía veterinaria especializada en <strong>traumatología y ortopedia</strong> con servicio móvil en <strong>Atarfe</strong> y área metropolitana de <strong>Granada</strong>. Especialista en <strong>TPLO</strong>, fracturas complejas, luxación de rótula y neurocirugía.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <a href="#contacto" onClick={(e) => { e.preventDefault(); document.getElementById('contacto')?.scrollIntoView({ behavior: 'smooth' }); }} className="inline-flex items-center space-x-2 bg-gradient-to-r from-accent-600 to-accent-700 text-white px-8 py-4 rounded-lg font-semibold hover:from-accent-700 hover:to-accent-800 transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105 whitespace-nowrap cursor-pointer">
                <span>Solicitar Valoración (24h)</span><i className="ri-arrow-right-line"></i>
              </a>
              <a href="tel:+34600581975" className="inline-flex items-center space-x-2 bg-white text-accent-700 px-8 py-4 rounded-lg font-semibold hover:bg-accent-50 transition-all duration-300 shadow-lg hover:shadow-xl border-2 border-accent-200 whitespace-nowrap cursor-pointer">
                <i className="ri-phone-line"></i><span>Llamar: 600 581 975</span>
              </a>
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="prose prose-lg max-w-none">
            <p className="text-lg text-gray-700 leading-relaxed mb-6">
              Como <strong>traumatólogo veterinario especialista en Atarfe</strong>, ofrezco un servicio completo de <strong>cirugía veterinaria móvil</strong> en toda el área metropolitana de <strong>Granada</strong>. Con más de 25 años de experiencia y casi 5000 cirugías realizadas, me especializo en <strong>traumatología y ortopedia veterinaria</strong>, llevando equipamiento de última generación directamente a tu clínica en <strong>Atarfe</strong>.
            </p>
            <p className="text-lg text-gray-700 leading-relaxed mb-6">
              Mi servicio de <strong>cirugía veterinaria en Atarfe</strong> incluye procedimientos especializados como <strong>cirugía TPLO</strong> para rotura de ligamento cruzado, tratamiento de fracturas complejas, luxación de rótula, deformidades angulares, displasias, neurocirugía y cirugía oncológica. Todo ello sin que tu paciente tenga que desplazarse fuera de su clínica de confianza en <strong>Atarfe</strong>.
            </p>
          </div>
        </div>
      </section>

      <section className="py-20 bg-gradient-to-b from-gray-50 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
              Servicios de <strong>Traumatología Veterinaria</strong> en Atarfe
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Cirugía especializada con equipamiento de última generación en tu clínica de <strong>Atarfe</strong>
            </p>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {servicios.map((servicio, index) => (
              <div key={index} className="bg-white rounded-xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-100 hover:border-accent-200 hover:-translate-y-2">
                <div className="w-16 h-16 bg-gradient-to-br from-accent-100 to-accent-200 rounded-2xl flex items-center justify-center mb-6">
                  <i className={`${servicio.icon} text-3xl text-accent-600`}></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
                  <strong>{servicio.titulo}</strong>
                </h3>
                <p className="text-gray-600 leading-relaxed">{servicio.descripcion}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
              ¿Por Qué Elegir un <strong>Traumatólogo Veterinario Especialista</strong>?
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Experiencia, tecnología y dedicación exclusiva a la cirugía veterinaria en <strong>Atarfe</strong>
            </p>
          </div>
          <div className="grid md:grid-cols-2 gap-8">
            {razones.map((razon, index) => (
              <div key={index} className="flex items-start space-x-6 bg-gradient-to-br from-accent-50 to-white p-8 rounded-xl border border-accent-100 hover:border-accent-300 transition-all duration-300 hover:shadow-lg">
                <div className="w-14 h-14 bg-gradient-to-br from-accent-600 to-accent-700 rounded-xl flex items-center justify-center flex-shrink-0">
                  <i className={`${razon.icon} text-2xl text-white`}></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3" style={{ fontFamily: "'Playfair Display', serif" }}>{razon.titulo}</h3>
                  <p className="text-gray-600 leading-relaxed">{razon.descripcion}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-20 bg-gradient-to-b from-gray-50 to-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold text-gray-900 mb-6" style={{ fontFamily: "'Playfair Display', serif" }}>
            Cobertura en <strong>Atarfe</strong> y Área Metropolitana
          </h2>
          <p className="text-lg text-gray-600 mb-8 leading-relaxed">
            Servicio móvil de <strong>cirugía veterinaria especializada</strong> en <strong>Atarfe</strong>, Granada capital, Maracena, Albolote, Peligros y toda el área metropolitana de <strong>Granada</strong>. Me desplazo a tu clínica veterinaria con todo el equipamiento necesario para realizar cirugías complejas de <strong>traumatología y ortopedia</strong>.
          </p>
          <div className="bg-white rounded-xl shadow-lg p-8 border border-gray-200">
            <div className="flex items-center justify-center space-x-3 mb-4">
              <i className="ri-map-pin-line text-3xl text-accent-600"></i>
              <h3 className="text-2xl font-bold text-gray-900" style={{ fontFamily: "'Playfair Display', serif" }}>Zona de Servicio</h3>
            </div>
            <p className="text-gray-700 text-lg">
              <strong>Atarfe</strong>, Granada, Maracena, Albolote, Peligros, Santa Fe y toda el área metropolitana de <strong>Granada</strong>
            </p>
          </div>
        </div>
      </section>

      <section id="contacto" className="py-20 bg-gradient-to-br from-accent-600 to-accent-700">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold text-white mb-6" style={{ fontFamily: "'Playfair Display', serif" }}>
            ¿Necesitas un <strong>Traumatólogo Veterinario</strong> en Atarfe?
          </h2>
          <p className="text-xl text-white/90 mb-8 leading-relaxed">
            Contacta conmigo para una valoración especializada de tu caso. Servicio móvil en <strong>Atarfe</strong> y toda el área metropolitana de <strong>Granada</strong> con equipamiento de última generación.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a href="/#contacto" className="inline-flex items-center space-x-2 bg-white text-accent-700 px-8 py-4 rounded-lg font-semibold hover:bg-gray-50 transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105 whitespace-nowrap cursor-pointer">
              <span>Solicitar Valoración Urgente (24h)</span><i className="ri-arrow-right-line"></i>
            </a>
            <a href="tel:+34600581975" className="inline-flex items-center space-x-2 bg-accent-800 text-white px-8 py-4 rounded-lg font-semibold hover:bg-accent-900 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer">
              <i className="ri-phone-line"></i><span>Llamar: 600 581 975</span>
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}